import React, { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FMessage, iFMessage } from '../../../../hoc/IntlComponents';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import LandingApiRequests from '../../../../components/TransferApi/LandingApiRequests';
import VKApiRequests from '../../../../components/TransferApi/VKApiRequests';
import FBApiRequests from '../../../../components/TransferApi/FBApiRequests';
import ApiRequests from '../../../../components/TransferApi/ApiRequests';
import { useCardNavTabsWithRoutes } from '../../../../components/Card/cardHelpers';
import ApiPageNav from '../../components/TransferRequestByIP/ApiPageNav';

const tabKeys = {
    orders: 1,
    'orders-vk': 2,
    'orders-fb': 3,
    api: 4,
};

const navs = intl => [
    {
        id: 0, translate: <a
            className="nav-link"
            title={iFMessage({ intl, id: 'transfer-by-api.nav.landing.title' })}
        >
            <FMessage id="transfer-by-api.nav.landing.title" />
        </a>
    },
    {
        id: 1, translate: <a
            className="nav-link"
            title={iFMessage({ intl, id: 'transfer-by-api.nav.vk.title' })}
        >
            <FMessage id="transfer-by-api.nav.vk.title" />
        </a>
    },
    {
        id: 2, translate: <a
            className="nav-link"
            title={iFMessage({ intl, id: 'transfer-by-api.nav.fb.title' })}
        >
            <FMessage id="transfer-by-api.nav.fb.title" />
        </a>
    },
    {
        id: 3, translate: <a
            className="nav-link"
            title={iFMessage({ intl, id: 'transfer-by-api.nav.api.title' })}
        >
            <FMessage id="transfer-by-api.nav.api.title" />
        </a>
    },
];



const TransferRequestByIPPage = ({ intl, api_key, history }) => {
    // const { activeTab, handleTabChange } = useCardNavTabsWithRoutes({ tabKeys, history });
    const [activeTab, switchTab] = useState(0)

    const renderTabs = activeTab => {
        switch (activeTab) {
            case 0:
                return <LandingApiRequests tabProps={{ api_key, history }} type='landings' />
            case 1:
                return <VKApiRequests tabProps={{ api_key, history }} type='vk' />
            case 2:
                return <FBApiRequests tabProps={{ api_key, history }} type='fb' />
            case 3:
                return <ApiRequests tabProps={{ api_key, history }} type='api' />
            default:
                break;
        }
    }

    return (
        <Layout formattedTitle="pages.transfer-request-by-api.title">
            <Layout.Col className='transfer-api'>
                <h3 className='page-title'>API</h3>
                <ApiPageNav switchTab={switchTab} activeTab={activeTab} navItems={navs(intl)} />
                <Card>
                    {renderTabs(activeTab)}
                </Card>
            </Layout.Col>
        </Layout>
    );
};

const mapStateToProps = ({ webmaster }) => ({
    api_key: webmaster.profile.api_key,
});

export default connect(
    mapStateToProps,
)(injectIntl(TransferRequestByIPPage));
